/**
 * Navigation Hover
 *
 * @author Sadi Qevani
 */

(function (window, document, $) {
  "use strict";

  $(function () {

    /**
     * TimeOuts the Main navigation,
     * So the user has a better UX when hovering over the page
     * And its not disruptive.
     */

    var $navigationMenu    = $(".header-navigation-menu");
    var $navigationSubMenu = $(".header-navigation-sub-menu");
    var timeOutHandler     = null;

    $navigationMenu.find("li").hover(function () {
      var that = this;
      timeOutHandler = setTimeout(function () {
        $(that).find(".header-navigation-sub-menu").addClass("visible");
      }, 300);
    }, function () {
      $(this).find(".header-navigation-sub-menu").removeClass("visible");
      return clearTimeout(timeOutHandler);
    });

  });

}(window, document, jQuery));
